import Moment from 'moment';
import 'moment/locale/fr';

const isoStringToDateString = (isostring) => {
    var date = new Date(isostring);
    Moment.locale('fr');
    return Moment(date).format('DD/MM/YYYY - HH:mm')
}

export {isoStringToDateString}